import { DispatchType } from '../../../@types/redux-types'
import { priceMaximizerReset, priceMaximizerSuccess } from '../../reducers/priceMaximizer/priceMaximizerFeature'
import { getSavedSearches, getSimilarObjects } from '../../../api/priceMaximizer/priceMaximizerApi'
import { PriceMaximizerInput } from '../../../@types/price-maximizer-types'
import { getDefaultLogger } from '../../../services/logger/logger'
import { isAbortedError } from '../../../utils/customFetch'

export const loadPriceMaximizer = (realEstateData: PriceMaximizerInput) => async (dispatch: DispatchType) => {
  try {
    const [savedSearches, similarObjects] = await Promise.all([
      getSavedSearches(realEstateData),
      getSimilarObjects(realEstateData),
    ])
    if (savedSearches === undefined || similarObjects === undefined) {
      dispatch(priceMaximizerReset())
    } else {
      dispatch(
        priceMaximizerSuccess({
          priceMaximizerResult: {
            savedSearches: savedSearches,
            similarObjects: similarObjects,
          },
        })
      )
    }
  } catch (error) {
    if (isAbortedError(error)) {
      getDefaultLogger().info('loadPriceMaximizer failed because request is aborted', error)
    } else {
      getDefaultLogger().warn('loadPriceMaximizer', error)
    }
    dispatch(priceMaximizerReset())
  }
}
